import React from 'react'
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useTranslation } from 'react-i18next';
import {
    ModalHeader,
    ModalContent,
    ModalActions,
    Button,
    Modal,
  } from 'semantic-ui-react'
  


  function modalReducer(state, action) {
    switch (action.type) {
      case 'close':
        return { open: false }
      case 'open':
        return { open: true, size: action.size }
      default:
        throw new Error('Unsupported action...')
    }
  }
  
  const ShareModal = () => {
    const { t } = useTranslation();
    const [state, dispatch] = React.useReducer(modalReducer, {
      open: false,
      size: undefined,
    })
    const { open, size } = state
  
    return (
      <>
        <Button  style={{backgroundColor: "white"}}  onClick={() => dispatch({ type: 'open', size: 'mini' })}>
        <img className="top-bar-icon" src={process.env.PUBLIC_URL + `/img/share.svg`} alt="share icon" />
        </Button>
        
  
        <Modal style={{maxHeight: "250px",     
    margin: "auto", top: "auto", left: "auto"}}
          size={size}
          open={open}
          onClose={() => dispatch({ type: 'close' })}
        >
          <ModalHeader>{t('share_button')}</ModalHeader>
          <ModalContent>
            <Row>
            <Col>
                            <a href={`https://www.facebook.com/sharer/sharer.php?u` + window.location.origin} alt="facebook" title="facebook" target="_blank" rel="noreferrer" >
                                <img style={{height: "32px"}} src="https://www.fao.org/ResourcePackages/FAO/assets/dist/img/social-icons/social-icon-facebook.svg" alt="facebook" />
                            </a>
                            </Col>
                            <Col>
                            <a href={`https://www.linkedin.com/shareArticle?mini=true&title=Home&url=` + window.location.origin} alt="linkedin" title="linkedin" target="_blank" rel="noreferrer" >
                                <img style={{height: "32px"}} src="https://www.fao.org/ResourcePackages/FAO/assets/dist/img/social-icons/social-icon-linkedin.svg" alt="linkedin" />
                            </a>
                            </Col>
                            <Col>
                            <a href={`https://pinterest.com/pin/create/button/?url=` + window.location.origin + `&description=Home`} alt="pinterest" title="pinterest" target="_blank" rel="noreferrer" >
                                <img style={{height: "32px"}} src="https://www.fao.org/ResourcePackages/FAO/assets/dist/img/social-icons/social-icon-pinterest.svg" alt="pinterest" />
                            </a>
                            </Col>
                            <Col>
                            <a href={`https://twitter.com/intent/tweet?text=` + window.location.origin} alt="twitter X" title="twitter X" target="_blank" rel="noreferrer" >
                                <img style={{height: "32px"}} src="https://www.fao.org/ResourcePackages/FAO/assets/dist/img/social-icons/social-icon-twitter-x.svg" alt="twitter" />
                            </a>
                            </Col>

       
                            </Row>
          </ModalContent>
          <ModalActions>
            <Button style={{color: "white", backgroundColor: "#116AAB"}} onClick={() => dispatch({ type: 'close' })}>{t('close_modal')}</Button>
          </ModalActions>
        </Modal>
      </>
    )
  }
export default ShareModal
